export enum PopupResult {
  Yes = 'Yes',
  No = 'No',
  Ok = 'Ok',
  Cancel = 'Cancel',
}
